import Vue from 'vue'
import Component from 'vue-class-component'
import Layout from '@/apps/core/components/Layout'
import sections from '@/apps/dido/views/defaultNavigationDrawerSections'
import PendingDownloadListTable from '../../components/tables/PendingDownloadListTable/PendingDownloadListTable.vue'

@Component({
  components: {
    Layout,
    PendingDownloadListTable
  },
  props: {},
  computed: {}
})

class PendingDownloadListView extends Vue {
  sections = sections
}

export default PendingDownloadListView
